import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import NumberFormat from "react-number-format";
import { getProductInfo } from "../inventory/utils.inventory";
import { Fragment } from "react";
import { actions } from "../../../redux/actions/shoppingCart";
import { connect } from "react-redux";
import styles from "../../../styles/global-styles";

const useStyles = makeStyles(() => ({
  box: {
    margin: "20px 0px 20px 0px",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "80%",
      border: "0.2px solid #f2f2f2",
      fontSize: 18,
    },
  },
  labelDiscount: {
    marginTop: -10,
    fontWeight: 700,
    color: "#1C2668",
    opacity: 0.5,
    fontSize: 14,
    padding: 10,
  },
  body: styles.body,
  deleteLink: styles.deleteLink,
}));

const InfoChipsProduct = ({
  cart,
  itemRemoved,
  chipNumbers,
  removeItemFromCart,
}) => {
  const classes = useStyles();

  const [chipNumbersObj, setChipNumbersObj] = useState({});

  useEffect(() => {
    let iccidArray = [];
    if (Object.keys(chipNumbersObj).length) {
      Object.entries(chipNumbersObj).map(([key, value]) => {
        if (!iccidArray[key]) {
          iccidArray.push({ [key]: value });
        } else {
          iccidArray[key] = value;
        }
      });

      chipNumbers(iccidArray);
    }
  }, [chipNumbersObj]);

  const associateNumberToChip = ({ target: { value } }, chipId) => {
    if (value === "") {
      const copy = { ...chipNumbersObj };
      delete copy[chipId];
      setChipNumbersObj(copy);
    } else {
      setChipNumbersObj({ ...chipNumbersObj, [chipId]: value });
    }
  };

  const handleDeleteProductFromCart = (item) => {
    removeItemFromCart({ item });
    itemRemoved();
  };

  return (
    <>
      {Object.values(cart)
        .filter((item) => item.productTypeId === 3)
        .map((product, i) => {
          return (
            <Fragment key={i}>
              <Grid
                container
                direction="row"
                spacing={1}
                justify="space-around"
                alignItems="flex-end"
              >
                <Grid item>
                  <Typography
                    variant="body1"
                    component={"span"}
                    className={classes.body}
                  >
                    X {product.quantity}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2" component={"span"}>
                    {getProductInfo(product)}
                  </Typography>
                </Grid>
                <Grid item>
                  <NumberFormat
                    value={product.chip?.price || 0}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </Grid>
                <Grid item>
                  <span
                    className={classes.deleteLink}
                    onClick={() => handleDeleteProductFromCart(product)}
                  >
                    Eliminar
                  </span>
                </Grid>
              </Grid>
              {product.chip && (
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  justify="center"
                  alignItems="flex-start"
                >
                  <Grid item>
                    <span className={classes.labelDiscount}>Teléfono</span>
                  </Grid>
                  <Box className={classes.box}>
                    <InputMask
                      mask="9999999999"
                      inputProps={{
                        maxLength: 10,
                      }}
                      maskChar=""
                      onChange={(e) => associateNumberToChip(e, product.chipId)}
                    >
                      {() => (
                        <TextField
                          name="number"
                          placeholder="# Teléfono"
                          className={classes.textField}
                          variant="outlined"
                        />
                      )}
                    </InputMask>
                  </Box>
                </Grid>
              )}
            </Fragment>
          );
        })}
    </>
  );
};

const dispatch = {
  removeItemFromCart: actions.removeItemFromCart,
};

export default connect(null, dispatch)(InfoChipsProduct);
